module.exports = __webpack_public_path__ + "img/admin2.a7c30d14.svg";